import React, { useState, useRef } from "react";
import { variables } from "../utility/variables";
import { useMsal } from '@azure/msal-react';
import { useNavigate } from "react-router-dom";

const NewRoster = ({ managementId, preventSubmit = null }) => {
  const [highlight, setHighlight] = useState(false);
  const [fileAdded, setFileAdded] = useState(null);
  const [dropMessage, setDropMessage] = useState('Drag & Drop file here or click to browse');
  const [uploadedFileStatus, setUploadedFileStatus] = useState(null);
  const fileInputRef = useRef(null);
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);

    const files = e.dataTransfer.files;
    setFileAdded(files[0]);
    setDropMessage(files[0].name);
  };

  const reset = () => {
    setFileAdded(null);
    setDropMessage('Drag & Drop file here or click to browse');
  }

  const handleClick = () => {
    fileInputRef.current.click(); // Trigger file input dialog
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    setFileAdded(files[0]);
    setDropMessage(files[0].name);
  };

  const handleSubmitRoster = async () => {
    if( fileAdded == null ) {
      console.error('uploading file is empty ');
      setUploadedFileStatus('File Error: There is no roster file to submit.' );
      reset();
      return;
    }
    const formData = new FormData();
      formData.append('rosterfile', fileAdded);
      formData.append("managementId", `${managementId}`);
      // const accesstoken = sessionStorage.getItem("accessToken");
      // step 1: if no active account, re-direct to sign in page
    const userActiveAccount = await instance.getActiveAccount();
    if(!userActiveAccount){
      navigate('/signin');
    }
    const userEmail = userActiveAccount.username;
    console.log('userEmail', userEmail);
    // step 2: get access token
    const tokenResponse = await instance.acquireTokenSilent({
      scopes: [`api://${process.env.REACT_APP_ROSTER_CLIENTID}/access_as_user`],
      account: userActiveAccount,
    });
    const accesstoken = tokenResponse.accessToken;
    console.log('accesstoken', accesstoken);
      fetch(variables.API_URL +'Roster/upload', {
        method: 'POST',
        body: formData,
        credentials: "include", // important to send/set cookies
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            const errorMessage = errorData.messgae || errorData.status || 'An unknown error occurred';
            throw new Error(`Error ${response.status}: ${errorMessage}`);
          });
        }
        return response.json()
      })
      .then(data => {
        console.log('File successfully uploaded:', data);
        setUploadedFileStatus(data.messgae);
        //submitRosterDatabase()
        reset();
      })
      .catch(error => {
          console.error('Error uploading file: ', error);
          setUploadedFileStatus('File Error: \n' + error.message.replace("Error: Error 400: Failed:", "").replace("Error 400: ", "").replaceAll(";", "\n").replaceAll("Validation failed:", "Validation failed:\n"));
          reset();
      });
  }

  const handleDownloadTemplate = async (e) => {
    e.preventDefault(); // Prevent default anchor behavior

    try {
      // // const accesstoken = sessionStorage.getItem("accessToken");
      // // step 1: if no active account, re-direct to sign in page
      // const userActiveAccount = await instance.getActiveAccount();
      // if(!userActiveAccount){
      //   navigate('/signin');
      // }
      // const userEmail = userActiveAccount.username;
      // console.log('userEmail', userEmail);
      // // step 2: get access token
      // const tokenResponse = await instance.acquireTokenSilent({
      //   scopes: [`api://${process.env.REACT_APP_ROSTER_CLIENTID}/access_as_user`],
      //   account: userActiveAccount,
      // });
      // const accesstoken = tokenResponse.accessToken;
      // console.log('accesstoken', accesstoken);
      const response = await fetch(variables.API_URL +`Roster/template/${managementId}`, {
        method: "GET",
        mode: "cors",
        credentials: "include", // important to send/set cookies
    })

      if (!response.ok) {
        throw new Error("File download failed.");
      }

      // Convert the response to a Blob
      const blob = await response.blob();

      // Create a link element to trigger the download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Get the filename from the content-disposition header (if available)
      const contentDisposition = response.headers.get("Content-Disposition");
      console.log(contentDisposition);
      let fileName = "Roster_Template.xlsm";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
            fileName = match[1];
        }
    }
      // Set the filename and trigger the download
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up by revoking the object URL
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }

  return (
    <div className="m-20">
      <div id="newRosterStep1" className="mb-8">
        <h1 className="font-bold text-2xl mb-1">Step 1.</h1>
        <span className="ml-5">
          Download and fill out the <a className="text-blue-600 font-bold underline cursor-pointer" onClick={handleDownloadTemplate}>Roster Template</a> in Excel.
        </span>
        <h5>   ( please use latest template for roster upload )</h5>
      </div>
      <div id="newRosterStep2" className="mb-8">
        <h1 className="font-bold text-2xl mb-1">Step 2.</h1>
        <div
          id="newRoster_drop-area"
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={handleClick}
          className={`ml-5 ${highlight ? "highlight" : ""}`}
          style={{
            width: "300px",
            height: "200px",
            border: "2px dashed #ccc",
            borderRadius: "10px",
            textAlign: "center",
            padding: "50px",
            cursor: "pointer",
            transition: "background-color 0.3s",
          }}
        >
          <p id="drop-message">{dropMessage}</p>
          <input
            type="file"
            accept=".xls,.xlsx,.xlsm"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </div>
      </div>
      <div id="newRosterStep3" className="mb-8">
        <h1 className="font-bold text-2xl mb-1">Step 3.</h1>
        <button 
          className={`p-2 rounded-lg text-white border ml-5 ${preventSubmit ? 'cursor-not-allowed bg-gray-400' : 'bg-cyan-400'}`} 
          disabled={preventSubmit} 
          title={preventSubmit || 'Submit Attached Roster'}
          onClick={handleSubmitRoster}
        >
          Submit New Roster
        </button>
        {uploadedFileStatus && <div style={{ whiteSpace: 'pre-line' }} className={`font-bold text-lg ${uploadedFileStatus.includes('File Error') ? 'text-red-500' : 'text-green-800'}`}>{uploadedFileStatus}</div>}
      </div>
    </div>
  );
};

export default NewRoster;
